import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { AddEditModalGeneric } from '../../../ui/generics';
import { IArticle } from '../../../core/interfaces';
import { AddEditArticleFormComponent } from '../../forms/add-edit-article-form/add-edit-article-form.component';
import { ArticleEtikettenModalsService } from '../../../pages/article-labels/core/services/ArticleEtikettenModalsService';
import { AddArticleLabelModalComponent } from '../../../pages/article-labels/modals/add-article-label-modal/add-article-label-modal.component';
import { AddEditRoundLabelModalComponent } from '../../../pages/article-labels/modals/add-edit-round-label-modal/add-edit-round-label-modal.component';
import { EditLabelModalComponent } from '../../../pages/labels-printer/edit-label-modal/edit-label-modal.component';

@Component({
    selector: 'app-add-edit-article-modal',
    templateUrl: './add-edit-article-modal.component.html',
    styleUrls: ['./add-edit-article-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AddEditArticleModalComponent extends AddEditModalGeneric<IArticle, AddEditArticleFormComponent>
  implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('addArticleLabelModal') addArticleLabelModal: AddArticleLabelModalComponent;
  @ViewChild('addEditRoundLabelModal') addEditRoundLabelModal: AddEditRoundLabelModalComponent;
  @ViewChild('editLabelModal') editLabelModal: EditLabelModalComponent;

  @Output() articleCreated = new EventEmitter<IArticle>();
  @Output() mhdChanged = new EventEmitter<void>();

  constructor(
    protected cdr: ChangeDetectorRef,
    private readonly _etikettenModals: ArticleEtikettenModalsService,
  ) {
    super(cdr);
  }

  ngAfterViewInit(): void {
    this._etikettenModals.register({
      add: this.addArticleLabelModal,
      round: this.addEditRoundLabelModal,
      ownBrand: this.editLabelModal,
    });
  }

  ngOnDestroy(): void {
    this._etikettenModals.unregister();
    super.ngOnDestroy();
  }

  rebuildTitle(): void {
    this.title = this.isNew ? 'Neuen Artikel erstellen' : `Artikel bearbeiten: ${this.object.name}`;
  }

  onEtikettenRefresh(): void {
    this._etikettenModals.refreshList();
  }

  onOpenOwnBrand(event: { variantId: number; labelType: string }): void {
    this.editLabelModal?.showModal(event.variantId, { labelType: event.labelType });
  }
}
